import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { validationsByAgentId } from "../graphql/queries";
import { ValidationsByAgentIdQuery } from "../API";

export async function fetchAgentValidations(
  agentId: string
): Promise<GraphQLResult<ValidationsByAgentIdQuery>> {
  return API.graphql(
    graphqlOperation(validationsByAgentId, {
      agentId: agentId,
    })
  ) as Promise<GraphQLResult<ValidationsByAgentIdQuery>>;
}
